<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="Part01"><strong><em><img alt="Image" src="images/f1.jpg"/> Rachel <img alt="Image" src="images/f2.jpg"/></em></strong></h2>
<p class="break"> <a id="Page_5"></a><a id="Page_6"></a></p><a id="Page_6">
</a><p class="ded"><a id="Page_6">For Amy Pierpont,<br/>with love and appreciation</a><a id="Page_7"></a></p><a id="Page_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?7461bca0